module.exports = __webpack_public_path__ + "img/stop_btn.1ff9dcd8.png";